import { render, staticRenderFns } from "./gs-article-item.vue?vue&type=template&id=5ad8e1d6"
import script from "./gs-article-item.vue?vue&type=script&lang=ts"
export * from "./gs-article-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports